
import WelcomePage from 'pages/WelcomePage/WelcomePage';
import CategoryProductsPage from 'pages/CategoryProductsPage/CategoryProductsPage';
import ProductPage from 'pages/ProductPage/ProductPage';
import ShopPage from 'pages/Services/ShopPage/ShopPage';
import FoodPage from 'pages/Services/FoodPage/FoodPage';
import ITPage from 'pages/Services/ITPage/ITPage';
import ServersPage from 'pages/Services/ServersPage/ServersPage';
import CommunityPage from 'pages/Services/CommunityPage/CommunityPage';
import MoviePage from 'pages/Services/MoviePage/MoviePage';
import AnimePage from 'pages/Services/AnimePage/AnimePage';
import EventsPage from 'pages/Services/EventsPage/EventsPage';
import MediaPage from 'pages/Services/MediaPage/MediaPage';
import TourismPage from 'pages/Services/TourismPage/TourismPage';

export const routes = [
  { path: '/', component: <WelcomePage /> },
  { path: '/catalog', component: <CategoryProductsPage /> },
  { path: '/product', component: <ProductPage /> },
  
  // Services routes
  { path: '/services/shop', component: <ShopPage /> },
  { path: '/services/food', component: <FoodPage /> },
  { path: '/services/it', component: <ITPage /> },
  { path: '/services/servers', component: <ServersPage /> },
  { path: '/services/community', component: <CommunityPage /> },
  { path: '/services/movie', component: <MoviePage /> },
  { path: '/services/anime', component: <AnimePage /> },
  { path: '/services/events', component: <EventsPage /> },
  { path: '/services/media', component: <MediaPage /> },
  { path: '/services/tourism', component: <TourismPage /> },
]
